import { render, staticRenderFns } from "./basculas.vue?vue&type=template&id=9ba5c846&"
import script from "./basculas.vue?vue&type=script&lang=js&"
export * from "./basculas.vue?vue&type=script&lang=js&"
import style0 from "./basculas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports